var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58262 0.0271554H4.41727C4.25425 0.0676641 4.1411 0.178732 4.02704 0.29268C3.09578 1.22313 2.16334 2.15239 1.22969 3.08046C1.11832 3.19116 1.01146 3.3019 0.972656 3.46002L0.972656 3.63852C0.994054 3.65325 0.991478 3.67881 0.998822 3.69934C1.05405 3.85351 1.1573 3.95941 1.31398 4.00968C1.52553 4.07756 1.69906 4.01035 1.85072 3.85898C2.71516 2.99615 3.58088 2.13459 4.44454 1.27098C4.48848 1.22704 4.51032 1.22584 4.55505 1.27057C5.41383 2.12932 6.27442 2.98629 7.13489 3.84338C7.16567 3.87405 7.19738 3.90418 7.23136 3.93122C7.43568 4.09372 7.73477 4.06193 7.90692 3.86493C7.96574 3.79761 7.99003 3.71543 8.02723 3.63852V3.46002C7.98864 3.30176 7.88154 3.19116 7.7702 3.08048C6.83657 2.15239 5.9041 1.22313 4.97284 0.29268C4.85879 0.178732 4.74564 0.0676641 4.58262 0.0271554Z",
    fill: "#ADABAB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.b17801bb0d245d41e8708641a26b16f4.svg";
export { ForwardRef as ReactComponent };